import PersonalInfoBasicInfoForm from './PersonalInfoBasicInfoForm.component';

export default PersonalInfoBasicInfoForm;
